__turbopack_context__.v({
  "ratingBubble": "_7m65iq_ratingBubble",
  "wrapper": "_7m65iq_wrapper",
});
